module.exports = __webpack_public_path__ + "i18n/tr.c8a3b4a651aca4f344a7c506943d277c.json";